import {
  Box,
  Container,
  Hidden,
  Paper,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React, { useContext } from "react";
import { ProcessContext } from "../../../contexts/ProcessContext";
import { calculateHeaderHeights } from "../../../utils/calculateHeaderHeights";
import ResponsiveLayout from "./ResponsiveLayout";

export default function ResponsiveContainer({
  children,
  paperChildren = null,
}) {
  const isScreenXs = useMediaQuery(useTheme().breakpoints.down("xs"));

  const {
    state: { currentSection, sectionsArray, appStarted, hideSections },
  } = useContext(ProcessContext);

  const MARGIN_BOTTOM = "8px";

  const totalHeaderHeight =
    calculateHeaderHeights.getLogoContainerHeight(isScreenXs, appStarted) +
    calculateHeaderHeights.getSectionsHeight(
      isScreenXs,
      currentSection,
      sectionsArray,
      appStarted && !hideSections
    );

  return (
    <Container
      className="transition-all"
      maxWidth="sm"
      style={{
        height: `calc(100% - ${totalHeaderHeight}px)`,
        padding: 0,
        boxSizing: "border-box",
        position: "relative",
        zIndex: 1,
      }}
    >
      <Paper
        elevation={0}
        style={{
          minHeight: "100%",
          position: "relative",
          zIndex: 1,
          marginBottom: MARGIN_BOTTOM,
        }}
      >
        {paperChildren}
        <ResponsiveLayout overflowStyle={!isScreenXs}>
          {children}
        </ResponsiveLayout>
      </Paper>
      <Hidden xsDown>
        <Box style={{ height: MARGIN_BOTTOM }} />
      </Hidden>
    </Container>
  );
}
